<script setup></script>
<template>
    <svg viewBox="0 0 22 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.4324 44V23.9622H20.6519L21.5764 16.1167H14.4324V11.1195C14.4324 8.85558 15.0127 7.30556 18.0021 7.30556H21.79V0.310907C19.947 0.0962291 18.0945 -0.00742743 16.2409 0.000413583C10.7434 0.000413583 6.96903 3.6481 6.96903 10.3445V16.1021H0.790039V23.9475H6.98252V44H14.4324Z" fill="currentColor"/>
    </svg>
</template>